var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Information"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76758 16.5C13.1362 16.5 16.7676 12.8765 16.7676 8.5C16.7676 4.13137 13.1284 0.5 8.75974 0.5C4.38326 0.5 0.767578 4.13137 0.767578 8.5C0.767578 12.8765 4.39111 16.5 8.76758 16.5ZM8.76758 15.1667C5.06562 15.1667 2.10875 12.202 2.10875 8.5C2.10875 4.80588 5.05777 1.83333 8.75973 1.83333C12.4539 1.83333 15.4264 4.80588 15.4343 8.5C15.4421 12.202 12.4617 15.1667 8.76758 15.1667ZM8.69699 5.70784C9.26954 5.70784 9.7166 5.25294 9.7166 4.68824C9.7166 4.11569 9.26954 3.66078 8.69699 3.66078C8.12444 3.66078 7.67738 4.11569 7.67738 4.68824C7.67738 5.25294 8.12444 5.70784 8.69699 5.70784ZM7.38719 12.8137C7.07346 12.8137 6.82248 12.5863 6.82248 12.2647C6.82248 11.9588 7.07346 11.7157 7.38719 11.7157H8.36758V8.11569H7.52052C7.20679 8.11569 6.95581 7.88824 6.95581 7.56667C6.95581 7.26078 7.20679 7.01765 7.52052 7.01765H9.00287C9.39503 7.01765 9.61464 7.3 9.61464 7.72353V11.7157H10.5872C10.9088 11.7157 11.1597 11.9588 11.1597 12.2647C11.1597 12.5863 10.9088 12.8137 10.5872 12.8137H7.38719Z",
    fill: "#7B7B7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.44cfb5c41af09b151dc141ab1c884a3f.svg";
export { ForwardRef as ReactComponent };